import { Component, EventEmitter, Input, Output } from '@angular/core';
import { Notification, NotificationType } from '@app/models/notification.model';

@Component({
  selector: 'app-notifications-panel',
  templateUrl: './notifications-panel.component.html',
  styleUrls: ['./notifications-panel.component.scss'],
  standalone: false,
})
export class NotificationsPanelComponent {
  @Input() isOpen = false;
  @Input() notifications: Notification[] = [];
  @Output() markAllRead = new EventEmitter<void>();

  getIcon(type: NotificationType): string {
    switch (type) {
      case NotificationType.NEW_COMMENT: return 'chat_bubble_outline';
      case NotificationType.NEW_REFERRAL: return 'add_circle_outline';
      case NotificationType.ACTION_REQUIRED: return 'priority_high';
      case NotificationType.REFERRAL_ACCEPTED: return 'swap_horiz';
      default: return 'notifications';
    }
  }

  getIconClass(type: NotificationType): string {
    switch (type) {
      case NotificationType.NEW_COMMENT: return 'icon-comment';
      case NotificationType.NEW_REFERRAL: return 'icon-referral';
      case NotificationType.ACTION_REQUIRED: return 'icon-action';
      case NotificationType.REFERRAL_ACCEPTED: return 'icon-accepted';
      default: return '';
    }
  }

  formatTime(date: Date): string {
    return date.toLocaleTimeString('en-US', { hour: 'numeric', minute: '2-digit', hour12: true });
  }
}
